import { call, put } from 'redux-saga/effects';
import md5 from 'js-md5';
import { orderBy } from 'lodash';
import { List } from 'immutable';
import moment from 'utils/moment';
import { getReceiptsFileLink } from 'services/API';
import { fileKindMap } from 'modules/Taps/components/NDFL3/constants/FilesKindMap';
import subCategoriesMap from 'modules/Taps/constants/subcategoriesMap';
import { setReceiptsLinkSuccess } from 'modules/Taps/components/NDFL3Light/redux/actions';

/**
 * Creates receipts pdf file link and update draft
 */
export function* receiptsSaga({ payload: draft }) {
  const attaches = draft.getIn(['payload', 'attaches']) || List();
  const receipts = draft.getIn(['payload', 'checks']) || List();

  if (receipts.isEmpty()) {
    return yield put(
      setReceiptsLinkSuccess(
        draft.setIn(['payload', 'digestChecks'], '').setIn(
          ['payload', 'attaches'],
          attaches.filter(
            (attach) => attach.getIn(['additionalInfo', 'kind']) !== fileKindMap.checks,
          ),
        ),
      ),
    );
  } else {
    const receiptArrayHash = draft.getIn(['payload', 'digestChecks']);
    const formReceiptArrayHash = md5(receipts.toJS());
    const updatedDraft = draft.setIn(['payload', 'digestChecks'], formReceiptArrayHash);

    if (receiptArrayHash !== formReceiptArrayHash) {
      const { isOk, data: fileLink } = yield call(getReceiptsFileLink, updateReceipts(receipts));

      if (isOk) {
        return yield put(
          setReceiptsLinkSuccess(
            updatedDraft.withMutations((draft) => {
              draft.setIn(
                ['payload', 'attaches'],
                [
                  {
                    fileLink,
                    fileName: `Чеки для подтверждения вычетов`,
                    additionalInfo: { kind: fileKindMap.checks, description: 'Приложенные чеки' },
                  },
                  ...attaches
                    .filter(
                      (attach) => attach.getIn(['additionalInfo', 'kind']) !== fileKindMap.checks,
                    )
                    .toJS(),
                ],
              );
            }),
          ),
        );
      }
    }
  }

  return yield put(setReceiptsLinkSuccess(draft));
}

function updateReceipts(receipts) {
  return orderBy(
    receipts
      .map((check) =>
        check
          .set('originDate', moment(check.get('originDate')).startOf('day'))
          .set('categoryId', subCategoriesMap[check.get('subCategory')]),
      )
      .toJS(),
    ['categoryId', 'originDate'],
    ['asc', 'asc'],
  ).map(({ receiptId }) => receiptId);
}
